<div class="row container-form-list">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">Linhas de produção adicionadas na unidade de negócio</h6>
                <small class="card-subtitle mb-0">Adicione as linhas de produção que deseja vincular a unidade de negócio {{nomeUnidadeNegocio}}</small>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete" *ngIf="canEdit"></th>
                            <th class="col-linha-producao">Linha de Produção</th>
                            <th class="col-situacao text-center">Situação</th>
                            <th class="col-cotacao-item-formulario">Formulário Cotação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete" *ngIf="canEdit">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-linha-producao">
                                <select class="form-control" name="idLinhaProducao_{{i}}" id="idLinhaProducao_{{i}}"
                                    [ngModel]="entity.idLinhaProducao || ''" (ngModelChange)="onChangeLinhaProducao(entity, $event ? $event : null)"
                                    #selectLinhaProducao [disabled]="!canEdit">
                                    <option value="">Selecione a Linha de Produção...</option>
                                    <option *ngFor="let linhaProducao of linhasProducoes" [ngValue]="linhaProducao.id">{{linhaProducao.nome}}</option>
                                </select>
                            </td>
                            <td class="col-situacao text-center">
                                <span class="badge badge-success" *ngIf="entity.linhaProducao?.situacao === 1">Ativa</span>
                                <span class="badge badge-danger" *ngIf="entity.linhaProducao?.situacao === 2">Inativa</span>
                            </td>
                            <td class="col-cotacao-item-formulario">
                                <select class="form-control" name="cotacaoItemFormulario_{{i}}" id="cotacaoItemFormulario_{{i}}"
                                    [ngModel]="entity.cotacaoItemFormulario || ''" (ngModelChange)="entity.cotacaoItemFormulario = $event ? $event : null"
                                    [disabled]="!canEdit">
                                    <option value="">Nenhum...</option>
                                    <option *ngFor="let itemFormularioCotacao of itensFormulariosCotacao" [ngValue]="itemFormularioCotacao.id">{{itemFormularioCotacao.nome}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="4">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer" *ngIf="canEdit">
                <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Linha de Produção
                </button>
            </div>
        </div>
    </div>
</div>
